import React from 'react';
import { ISvg, Svg } from '@vfit/shared/atoms';
import * as S from './iconButton.style';
import { IconButtonVariant } from './iconButton.model';

type IconButtonProps = Pick<ISvg, 'name' | 'color' | 'width'> &
  React.ComponentPropsWithoutRef<'button'> & {
    variant?: IconButtonVariant;
  };

const IconButton: React.FC<IconButtonProps> = ({
  color,
  name,
  width,
  variant = 'default',
  ...rest
}) => {
  return (
    <S.ButtonContainer visible={rest.onClick !== undefined} {...rest} variant={variant}>
      <Svg name={name} color={color} width={width} />
    </S.ButtonContainer>
  );
};

export default IconButton;

